import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { extractSelectedTicketIdFromState, getNewMessagesEditor } from '../../../extractFromState';
import { DraftHelpers } from '../../../util/Draft';
import { saveNewMessageEditorState, setNewMessageCouponCodeType } from '../../../actions';
import { ActionsButtonsText } from '../../../components/common/fontElements';

export const MASK_CHAR = '⬜';

export class AddCouponCodeButtonComponent extends React.Component {
  state = {
    showInfo: false,
  };

  componentDidMount() {
    // preload hover image
    const image = new Image();
    image.src = '/images/coupon_code_dark.png';
  }

  insertTextIntoMessage(insertText) {
    let editorState = DraftHelpers.replaceCurrentSelection(insertText, this.props.editorState);
    this.props.saveNewMessageEditorState(this.props.ticketId, editorState);
  }

  setNewMessageCouponCodeType(macroCouponCodeTypeId) {
    this.props.setNewMessageCouponCodeType(this.props.ticketId, macroCouponCodeTypeId);
  }

  render() {
    if (this.props.active) {
      return (
        <AddCouponButtonWrapper>
          <AddCouponButton
            onMouseEnter={() => this.setState({ showInfo: true })}
            onMouseLeave={() => this.setState({ showInfo: false })}
            active={this.props.active}
          >
            ADDED
          </AddCouponButton>
        </AddCouponButtonWrapper>
      );
    }

    return (
      <AddCouponButtonWrapper>
        <AddCouponButton
          onMouseEnter={() => this.setState({ showInfo: true })}
          onMouseLeave={() => this.setState({ showInfo: false })}
          onClick={() => {
            this.insertTextIntoMessage(MASK_CHAR);
            this.setNewMessageCouponCodeType(this.props.couponCodeTypeId);
          }}
          active={this.props.active}
        >
          {this.state.showInfo && <InfoMessage>Insert masked coupon code</InfoMessage>}
          ADD
        </AddCouponButton>
      </AddCouponButtonWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const selectedTicketId = extractSelectedTicketIdFromState(state);
  const editorState = getNewMessagesEditor(state);
  const currentContent = editorState.getCurrentContent();
  const plainText = currentContent ? currentContent.getPlainText() : '';
  const active = plainText ? plainText.includes(MASK_CHAR) : false;

  return {
    ticketId: selectedTicketId,
    active,
    editorState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveNewMessageEditorState(conversationObjId, editorState) {
      dispatch(saveNewMessageEditorState(conversationObjId, editorState));
    },
    setNewMessageCouponCodeType(conversationObjId, macroCouponCodeTypeId) {
      dispatch(setNewMessageCouponCodeType(conversationObjId, macroCouponCodeTypeId));
    },
  };
};

export const AddCouponCodeButtonContainer = connect(mapStateToProps, mapDispatchToProps)(AddCouponCodeButtonComponent);
export default AddCouponCodeButtonContainer;

const AddCouponButtonWrapper = styled.div`
  background: #ffffff;
`;
const AddCouponButton = styled(ActionsButtonsText)`
  border: none;
  z-index: 2;
  width: 65px;
  margin: 0 -2.5px 0 0;
  padding: 0 5px 0 20px;
  height: 23px;
  font-family: Lato, sans-serif;
  font-size: 9.2px;
  font-weight: 400;
  color: #ffffff;
  background-size: 100% 100%;
  background-image: url('${(props) =>
    props.active ? '/images/new-designs/coupon-dark.svg' : '/images/new-designs/coupon.svg'}');
  background-color: transparent;
  outline: none;
  cursor: ${(props) => (props.active ? 'default' : 'pointer')};

  &:active {
    outline: none;
  }
`;

const InfoMessage = styled.div`
  position: absolute;
  bottom: 25px;
  padding: 2px 0;
  z-index: 4;
  width: 80px;
  display: block;
  background-color: #86e0e9;
  font-family: Lato, sans-serif;
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin-left: -50px;
`;
